<template>
    <div class="ui-content dashboard add-ch-arrow user-section">
        <v-card class="mx-auto normal-card autohg">
            <div class="add-user-form">
                <v-row class="add-user-teacher">
                    <v-col cols="12" sm="2" class="st-blk"></v-col>
                    <v-col cols="12" sm="8" class="st-data">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="teacherName"
                                    label="Name"
                                    class="required"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                                <InputError :data="error.teacherName" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="teacherEmail"
                                    label="Email ID"
                                    class="required"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                                <InputError :data="error.teacherEmail" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="selectedClass"
                                    @change="getSubjects()"
                                    :items="classes"
                                    label="Category"
                                    hide-details
                                    dense
                                    outlined
                                    class="required"
                                ></v-select>
                                <InputError :data="error.dataType" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <multi-select
                                    allText="All subjects"
                                    :items="subjects"
                                    :onChange="onSubjectSelect"
                                    v-model="selectedSubject"
                                    label="Select Subjects"
                                    hide-details
                                    dense
                                    outlined
                                    class="fix-200 required"
                                    filled
                                ></multi-select>
                                <InputError :data="error.subjects" />
                            </v-col>
                            <!-- <v-col cols="12" sm="6" class="b-data">
                                <multi-select
                                    allText="All Centers"
                                    :items="centers"
                                    ref="centerSelect"
                                    :onChange="onCenterchange"
                                    v-model="selectedCenterId"
                                    noText="No Center"
                                    label="Center"
                                    hide-details
                                    dense
                                    outlined
                                    class="fix-200"
                                    filled
                                ></multi-select>
                                <InputError :data="error.center" />
                            </v-col>
                            <v-col cols="12" sm="6" class="b-data">
                                <multi-select
                                    allText="All Batches"
                                    :items="batches"
                                    :onChange="onBatchSelect"
                                    v-model="selectedBatch"
                                    label="Batch"
                                    hide-details
                                    dense
                                    outlined
                                    class="fix-200"
                                    filled
                                ></multi-select>
                                <InputError :data="error.batch" />
                            </v-col> -->

                            <v-col cols="12" sm="6">
                                <div class="select-center-blk">
                                    <div class="teacher-border">
                                        <div
                                            v-if="selectedCenterList.length"
                                            class="selectedCenterListouter"
                                        >
                                            <div
                                                v-for="center in selectedCenterList"
                                                class="selectedCenterList"
                                            >
                                                <div class="center-name-v">
                                                    {{ center.text }}
                                                </div>

                                                <div class="radio-center">
                                                    <div
                                                        class="check-cust center-check"
                                                        v-for="batch in center.batches"
                                                        :title="batch.text"
                                                    >
                                                        <v-checkbox
                                                            v-model="
                                                                batch.checked
                                                            "
                                                            :label="batch.text"
                                                            dense
															:disabled="batch.disabled"
                                                            hide-details
                                                        ></v-checkbox>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                           
                                            <div
                                                class="select-center cp3-select-center"
                                            >
                                                <v-select
                                                    :items="centers"
                                                    v-model="selectedCenterId"
                                                    hide-details
                                                    dense
                                                    class="fix-200 required new-multiselect-cp-3"
                                                    filled
													solo
                                                    attach
                                                    auto
                                                    no-data-text="No centers available"
                                                    label="Allot Center & Batches"
                                                ></v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <InputError :data="error.batches" />
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12" class="rg-0">
                                <v-btn
                                    @click="onSubmit"
                                    :loading="loading"
                                    class="right-btn cust-btn"
                                    color="primary"
                                    >Done</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" class="st-blk"></v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: "AddUsersStudent",
     props: ["tab"],

    data() {
        return {
            loading: false,
            classes: [],
            subjects: [],
            selectedClass: null,
            page: 1,
            teacherEmail: null,
            teacherName: null,
            error: {
                teacherEmail: {
                    type: null,
                    message: null,
                },
                teacherName: {
                    type: null,
                    message: null,
                },
                dataType: {
                    type: null,
                    message: "Please select class",
                },
                subjects: {
                    type: null,
                    message: "Please select subject",
                },
                batches: {
                    type: null,
                    message: "Please Select Batch",
                },
            },
            selectedSubject: [],
            centers: [],
            selectedCenterId: [],
            batches: [],
            selectedBatch: [],
            selectedCenterList: [],
            selectedCenterId: null,
            showAddcenterButton: true,
        };
    },
    methods: {
        ...mapActions({
            getClasses: "userStore/getClasses",
            getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
            signUp: "userStore/signUp",
            getCenters: "centerAndBatchStore/getCentersByUser",
            getBatches: "centerAndBatchStore/getBatches",
        }),

        requestGetClasses() {
            let reqData = {
                level: 1,
            };

            this.getDataTreeWithLevel(reqData)
                .then((response) => {
                    this.loading = false;
                    this.classes = response.map((x) => {
                        let c = {};
                        c.text = x.title;
                        c.value = x;
                        return c;
                    });
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        getSubjects() {
            let reqData = {
                level: 2,
                parent: this.selectedClass.id,
            };
            this.subjects = [];
            this.selectedSubject = null;
            this.$root.showLoader = true;
            this.getDataTreeWithLevel(reqData)
                .then((response) => {
                    this.$root.showLoader = false;
                    this.subjects = response.map((x) => {
                        let c = {};
                        c.text = x.title;
                        c.value = x.id;
                        return c;
                    });
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onSubmit() {
            this.loading = true;

            if (this.validate()) {
                let details = null;
                let categories = this.selectedSubject;
                let batches = [];
                this.selectedCenterList.map((sc) => {
                    return sc.batches.map((b) => {
                        if (b.checked) {
                            batches.push(b.value);
                        }
                    });
                });
                this.signUp({
                    internal: true,
                    name: this.teacherName.trim(),
                    email: this.teacherEmail.trim(),
                    role_id: this.roleIds.TR,
                    categories: categories,
                    class: this.selectedClass.title,
                    batches: batches,
                })
                    .then((response) => {
                        this.loading = false;
                        this.teacherEmail = "";
                        this.teacherName = "";
                        this.selectedClass = null;
                        this.selectedSubject = null;

                        this.subjects = [];
                        this.batches = [];
                        this.selectedCenterList = [];
                        this.showAddcenterButton = true;
                        this.selectedCenterId = null;
                        this.requestGetCenters();
                        this.$toasted.success(`${response.message}`, {
                            icon: "check_circle", className:'new-class'
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        },
        validate() {
            this.teacherEmail = this.removeWhiteSpacesFromEmail(this.teacherEmail);
            let isValid = true;
            this.error.teacherName.type = null;
            this.error.teacherEmail.type = null;
            this.error.dataType.type = null;
            this.error.subjects.type = null;
            this.error.batches.type = null;
            let batches = [];
            this.selectedCenterList.map((sc) => {
                return sc.batches.map((b) => {
                    if (b.checked) {
                        batches.push(b.value);
                    }
                });
            });
            if (!this.teacherName || this.teacherName.trim().length < 1) {
                this.error.teacherName.type = "error";
                this.error.teacherName.message = "Please enter teacher name";
                isValid = false;
            }
            if (this.teacherName && this.teacherName.trim().length > 70) {
                this.error.teacherName.type = "error";
                this.error.teacherName.message = "Name should not contain more than 70 characters";
                isValid = false;
            }
            if (!this.teacherEmail || this.teacherEmail.length < 1) {
                this.error.teacherEmail.type = "error";
                this.error.teacherEmail.message =
                    "Please enter teacher email ID.";
                isValid = false;
            } else if (!this.isValidEmail(this.teacherEmail)) {
                this.error.teacherEmail.type = "error";
                this.error.teacherEmail.message =
                    "Please enter a valid email ID.";
                isValid = false;
            }
            if (!this.selectedClass) {
                this.error.dataType.type = "error";
                isValid = false;
            }
            if (this.selectedSubject==null || this.selectedSubject.length <= 0) {
                this.error.subjects.type = "error";
                isValid = false;
            }
            if (!batches || batches.length <= 0) {
                this.error.batches.type = "error";
                isValid = false;
            }

            return isValid;
        },
        onSubjectSelect(selectedSubject) {
            this.selectedSubject = selectedSubject;
			this.disableBatches()
        },

        requestGetCenters(alreadySelectedCenter) {
            this.centers = [];
            this.$root.showLoader = true;
            this.getCenters()
                .then((response) => {
                    this.$root.showLoader = false;
                    this.centers = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                    this.centers = this.centers.filter((c) => {
                        return alreadySelectedCenter.indexOf(c.value) === -1;
                    });
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onCenterchange(centerIds) {
            this.selectedCenterId = centerIds;
        },
        requestGetBatch(centerId) {
            let reqData = {
                center_id: [centerId],
            };

            this.getBatches(reqData)
                .then((response) => {
                    this.loading = false;
                    let tmpCenter = this.centers.filter(
                        (x) => x.value === centerId
                    );
                    if (response && response.list && response.list.length) {
                        let tmpBatch = response.list.map((x) => {
                            let c = {};
                            c.text = x.name;
                            c.value = x.id;
							c.subject_id = x.subject_ids.split(',').map(s=>parseInt(s));
                            c.checked = false;
                            return c;
                        });

                        this.selectedCenterList.push({
                            ...tmpCenter[0],
                            batches: tmpBatch,
                        });
                        this.centers = this.centers.filter(
                            (x) => x.value !== centerId
                        );
						this.disableBatches()
                    } else {
                        this.$toasted.error(
                            `Batches not available for center ${tmpCenter[0].text}`,
                            { icon: "info" }
                        );
                        this.centers = this.centers.filter(
                            (x) => x.value !== centerId
                        );
                        //   this.selectedCenterList.push({
                        //         ...tmpCenter[0],
                        //         batches: []

                        //     })

                        //     this.centers = this.centers.filter(x => x.value !== centerId)
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        onBatchSelect(batchId) {
            this.selectedBatch = batchId;
        },
		disableBatches(){
			this.selectedCenterList.map(center => {
				center.batches.map(b => {
					if(this.selectedSubject && this.selectedSubject.length){
					
						b.disabled = !(this.selectedSubject.findIndex(s=> b.subject_id.includes(s)) >=0)
					}else{
						b.disabled = true
					}
				})
			})
		}
    },
    watch: {
        selectedClass(val) {
            this.error.dataType.type = null;
        },
        teacherEmail(val) {
            if(this.teacherEmail){
            this.error.teacherEmail.type = null;
            }
        },
        teacherName(val) {
            this.error.teacherName.type = null;
        },
        selectedSubject(val) {
            this.error.subjects.type = null;
        },
        selectedCenterId(val) {
            if (this.selectedCenterId) {
                this.showAddcenterButton = true;
                this.requestGetBatch(val);
            }
        },
        tab(){
            this.teacherEmail = "";
            this.teacherName = "";
            this.selectedClass = null;
            this.selectedSubject = null;
            this.selectedCenterList = [];
            this.selectedCenterId=null;
            this.batches=[];
            this.classes=[];
            this.subjects=[];
            if(this.tab=='Teacher'){
              this.requestGetCenters();
              this.requestGetClasses();
            }

            this.error={
                teacherEmail: {
                    type: null,
                    message: null,
                },
                teacherName: {
                    type: null,
                    message: null,
                },
                dataType: {
                    type: null,
                    message: "Please select class",
                },
                subjects: {
                    type: null,
                    message: "Please select subject",
                },
                batches: {
                    type: null,
                    message: "Please Select Batch",
                },
            };
        }
    },
    mounted() {
        this.requestGetCenters();
        this.requestGetClasses();
    },
};
</script>
